"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));

var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));

var _Info = _interopRequireDefault(require("@material-ui/icons/Info"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Warning = _interopRequireDefault(require("@material-ui/icons/Warning"));

var _Slide = _interopRequireDefault(require("@material-ui/core/Slide"));

var _WithTheme = _interopRequireDefault(require("../WithTheme"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _theme = require("./theme");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var variantIcon = {
  success: _CheckCircle["default"],
  error: _Error["default"],
  info: _Info["default"],
  warning: _Warning["default"]
};

var UTAlert = /*#__PURE__*/function (_PureComponent) {
  _inherits(UTAlert, _PureComponent);

  function UTAlert() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, UTAlert);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(UTAlert)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClose", function (_, reason) {
      // In case you don't want to dismiss notification clicking away
      if (reason === 'clickaway') {
        return;
      }

      var alert = _this.props.content;
      return alert.onClose && alert.onClose();
    });

    _defineProperty(_assertThisInitialized(_this), "selectAlertType", function () {
      var _this$props = _this.props,
          alert = _this$props.content,
          classes = _this$props.classes;

      switch (alert.type) {
        case 'info':
          return classes.info;

        case 'error':
          return classes.error;

        case 'warning':
          return classes.warning;

        default:
          return classes.success;
      }
    });

    return _this;
  }

  _createClass(UTAlert, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _this$props2$content = _this$props2.content,
          alert = _this$props2$content === void 0 ? {} : _this$props2$content,
          withoutIcon = _this$props2.withoutIcon;
      var anchor = {
        vertical: alert.topRight ? 'top' : 'bottom',
        horizontal: alert.topRight ? 'right' : 'left'
      };
      var transition = {
        direction: alert.topRight ? 'left' : 'up'
      };
      var AlertTypeIcon = alert.type && variantIcon[alert.type];
      return _react["default"].createElement(_Snackbar["default"], {
        anchorOrigin: anchor,
        open: alert.open,
        autoHideDuration: alert.timeDuration,
        onClose: this.handleClose,
        TransitionProps: transition,
        TransitionComponent: _Slide["default"],
        classes: {
          root: _stylesModule["default"].snackbarRoot
        },
        ContentProps: {
          className: "".concat(_stylesModule["default"].snackbarContent, " ").concat(this.selectAlertType()),
          classes: {
            action: _stylesModule["default"].action,
            message: _stylesModule["default"].message
          }
        },
        message: _react["default"].createElement("div", {
          className: _stylesModule["default"].content
        }, !withoutIcon && AlertTypeIcon && _react["default"].createElement(AlertTypeIcon, {
          classes: {
            root: _stylesModule["default"].alertTypeIcon
          }
        }), alert.message),
        action: [_react["default"].createElement(_IconButton["default"], {
          key: "close",
          color: "inherit",
          onClick: this.handleClose
        }, _react["default"].createElement(_Close["default"], null))]
      });
    }
  }]);

  return UTAlert;
}(_react.PureComponent);

UTAlert.propTypes = {
  content: (0, _propTypes.shape)({
    message: _propTypes.string,
    open: _propTypes.bool,
    type: _propTypes.string,
    topRight: _propTypes.bool,
    timeDuration: _propTypes.number,
    onClose: _propTypes.func
  }),
  classes: (0, _propTypes.shape)({
    error: _propTypes.string,
    info: _propTypes.string,
    success: _propTypes.string
  }),
  withoutIcon: _propTypes.bool
};
UTAlert.defaultProps = {
  content: {
    open: false,
    type: undefined,
    message: undefined,
    topRight: undefined,
    timeDuration: undefined
  },
  classes: {}
};

var _default = (0, _WithTheme["default"])(_theme.retrieveStyle, _theme.retrieveMuiTheme)(UTAlert);

exports["default"] = _default;